import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { ButtonThemeService } from 'ui-components/services/button-theme-service';

import { TagPropType } from '../../prop-types/tag';
import { TagDropdownItem } from './tag-dropdown-item';
import { ManageTags } from './manage-tags';
import style from './tag-dropdown.module.less';
import messages from './messages';

const defaultButtonText = <FormattedMessage {...messages.addTag} />;

const TagDropdown = ({
  tags,
  selectedTags,
  className,
  theme = 'link',
  onTagToggled,
  menuPosition = 'bottom-left',
  buttonText = defaultButtonText,
  dropdownMenuShouldHaveWidthOfButton = false,
  dropdownMenuTogglerClass = '',
  dropdownMenuClassName = null,
  manageTagsAction = null,
}) => (
  <DropdownMenu
    className={className}
    closeWhenChildrenClicked={false}
    dropdownMenuClassName={dropdownMenuClassName}
    dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
    menuPosition={menuPosition}
  >
    <DropdownMenuToggler className={dropdownMenuTogglerClass} theme={theme}>
      {buttonText}
    </DropdownMenuToggler>
    {manageTagsAction && <ManageTags manageTagsAction={manageTagsAction} />}
    {tags.map((tag, index) => (
      <TagDropdownItem key={index} isChecked={selectedTags.includes(tag)} onTagToggled={onTagToggled} tag={tag} />
    ))}
    <div>
      {tags.length === 0 && (
        <div className={style['no-tags-indicator']}>
          <FormattedMessage defaultMessage='Create and Manage Tags in Other Actions' description='tagDropdown' id='7R7p+h' />
        </div>
      )}
    </div>
  </DropdownMenu>
);

TagDropdown.propTypes = {
  tags: PropTypes.arrayOf(TagPropType).isRequired,
  selectedTags: PropTypes.arrayOf(TagPropType).isRequired,
  className: PropTypes.string,
  theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  onTagToggled: PropTypes.func.isRequired,
  menuPosition: PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  dropdownMenuTogglerClass: PropTypes.string,
  dropdownMenuClassName: PropTypes.string,
  manageTagsAction: PropTypes.func,
};

export default TagDropdown;
